import Information16 from '@carbon/icons-react/es/information/16';
import Timer16 from '@carbon/icons-react/es/timer/16';
import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { PanelHeaderTitle } from 'components/atoms/collapse';
import { IconShell } from 'components/atoms/icon-shell';

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-left: var(--spacing-03);
  }
`;

export const TimeEntrySettingTitle: FC = () => (
  <PanelHeaderTitle
    icon={<IconShell icon={<Timer16 />} />}
    title={
      <Wrapper>
        <FormattedMessage id="task.time_entry_setting" />
        <Tooltip
          title={<FormattedMessage id="task.time_entry_setting.info.tooltip" />}
        >
          <Information16 />
        </Tooltip>
      </Wrapper>
    }
  />
);
